import c from 'classnames';
import { useMemo, useState, Children } from 'react';
import { motion } from 'framer-motion';

import { Icon, Typography } from '@repo/ui';

import styles from './ExpandableList.module.css';

export const ExpandableList = ({
  max,
  children,
  onExpand,
}: {
  max: number;
  children: React.ReactNode;
  onExpand?: () => void;
}) => {
  const arrayChildren = useMemo(() => Children.toArray(children), [children]);
  const [isExpanded, setIsExpanded] = useState(false);

  const isCollapsible = arrayChildren.length > max;
  const visibleChildren =
    isCollapsible && !isExpanded ? arrayChildren.slice(0, max) : arrayChildren;

  const toggleExpanded = () => {
    if (!isExpanded) onExpand?.();
    setIsExpanded(!isExpanded);
  };

  return (
    <>
      <motion.div layout transition={{ duration: 0.15 }}>
        {visibleChildren}
      </motion.div>
      {isCollapsible && (
        <button
          className={c(styles.expandButton, !isExpanded && styles.fadeOverlay)}
          onClick={toggleExpanded}
          aria-expanded={isExpanded}
        >
          <Icon
            name={isExpanded ? 'chevronUp' : 'fileSearch02Filled'}
            size='s'
          />
          <Typography variant='caption' color='secondary'>
            {isExpanded ? 'See less' : 'See full list'}
          </Typography>
        </button>
      )}
    </>
  );
};
